export default function NoPhoto() {
    return (
        <div className="d-flex col-12 col-md-5 flex-column-reverse flex-md-row left-product product__left">
            <div className="left-product__slider-big"><img src="https://www.pride.ru/images/no-photo.jpg" className={'w-100'} alt=""/></div>
        </div>
    )
}